import firebase from 'firebase/app';
import db from '../firebaseInit';

const updateUserDataInFirebase = (userDataToStore, callbackFunc = null) => {
  const currentUser = firebase.auth().currentUser;
  userDataToStore.accountLastModifiedAt = firebase.firestore.FieldValue.serverTimestamp();
  db.collection('users')
    .doc(currentUser.uid)
    .set(userDataToStore, {merge: true})
    .then(function(documentData) {
      if (callbackFunc) {
        callbackFunc();
      }
    })
    .catch(function(error) {
      // console.error('Error adding user activity log: ', error);
      if (callbackFunc) {
        callbackFunc();
      }
    });
};

export default updateUserDataInFirebase;
